// src/components/dashboard/MostPurchasedProductsChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the necessary components for Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const MostPurchasedProductsChart = () => {
    const productsData = [
        { name: 'Premium Coffee Blend', purchases: 320 },
        { name: 'Organic Honey', purchases: 280 },
        { name: 'Artisan Bread', purchases: 250 },
        { name: 'Gourmet Cheese', purchases: 190 },
        { name: 'Freshly Baked Cookies', purchases: 175 },
        { name: 'Specialty Tea Assortment', purchases: 150 },
    ];

    // Sort data for "top purchased" descending
    productsData.sort((a, b) => a.purchases - b.purchases); // Sort ascending for horizontal bar chart display

    const data = {
        labels: productsData.map(p => p.name),
        datasets: [
            {
                label: 'Number of Purchases',
                data: productsData.map(p => p.purchases),
                backgroundColor: 'rgba(251, 191, 36, 0.8)', // Tailwind amber-400
                borderColor: 'rgba(251, 191, 36, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        indexAxis: 'y', // This makes it a horizontal bar chart
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: { size: 14, family: 'Inter, sans-serif' },
                    color: '#374151',
                },
            },
            title: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                bodyFont: { size: 14, family: 'Inter, sans-serif' },
                titleFont: { size: 16, family: 'Inter, sans-serif', weight: 'bold' }
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(209, 213, 219, 0.4)',
                },
                ticks: {
                    color: '#4b5563',
                    font: { size: 12, family: 'Inter, sans-serif' },
                    callback: function(value) {
                        return value.toLocaleString();
                    }
                },
                title: {
                    display: true,
                    text: 'Total Purchases',
                    color: '#4b5563',
                    font: { size: 14, family: 'Inter, sans-serif', weight: 'bold' }
                }
            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#4b5563',
                    font: { size: 12, family: 'Inter, sans-serif' }
                }
            },
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 h-96 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Most Purchased Products</h3>
            <p className="text-sm text-gray-500 mb-4">Top 6 products by purchase count</p>
            <div className="flex-1 relative">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default MostPurchasedProductsChart;